import { render } from "./ShowInvoice.vue?vue&type=template&id=1bfe1328"
import script from "./ShowInvoice.vue?vue&type=script&lang=js"
export * from "./ShowInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__